import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';

export const useStyles = (theme: Theme) =>
  createStyles({
    paperRoot: {
      display: 'flex',
      alignItems: 'center',
      padding: '10px 24px',
      borderBottom: `1px solid ${theme.custom.palette.colorGrayishBlue}`,
      maxHeight: '52px',
      minHeight: '52px',
    },
    stepSection: {
      display: 'flex',
    },
    listItemText: {
      transition: 'opacity 0.2s ease-out',
      marginLeft: 10,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    link: {
      textDecoration: 'auto',
      '&:hover': {
        opacity: 0.6,
      },
    },
  });
